/**
 * Converts eth to gwei
 *
 * @param eth {ether}
 */
export const ethToGwei = (eth: number) => {
  return eth * 10 ** 9
}
